import { useContext, useState } from "react";
import { AppContext } from "../contexts/AppContext";
import { useForm } from "react-hook-form";
import OtpInput from "react-otp-input";

import {
  addPasswordOtpValidation,
  autoTabField,
  base_url,
  errorResponseMessage,
  httpHeaderConfig,
} from "./const.prop";
import Counter from "../components/Counter";
import axios from "axios";
import { toast } from "react-toastify";

const ForgetResetOtp = () => {
  const appContext = useContext(AppContext);
  const {
    register,
    handleSubmit,
    getValues,
    setFocus,
    formState: { errors },
  } = useForm({
    defaultValues: {
      passcode: "",
    },
  });
  const [passCode, setPasscode] = useState("");

  const onChangePasscode = (passcode) => {
    setPasscode(passcode);
  };

  const submitHandler = async () => {
    if (passCode.length < 4) {
      toast.error("Please fill all the input fields");
      return;
    }
    try {
      const submitData = await axios.post(
        `${base_url}verify-forgot-code`,
        {
          code: passCode,
          userId: localStorage.getItem("userId"),
        },
        {
          headers: httpHeaderConfig,
        }
      );
      if (submitData.status === 200 || submitData.status === 201) {
        setTimeout(() => {
          localStorage.setItem(
            "resetPasswordConfirm",
            JSON.stringify({
              userId: localStorage.getItem("userId"),
              otp: `${passCode}`,
            })
          );
          appContext.updateModalState();
          appContext.updateLoaderState(false);
          appContext.updateModalType("resetPassword");
        }, 500);
      }
    } catch (error) {
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
        return;
      }
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: errorResponseMessage(error),
      });
    }
  };

  // const renderInput = (value, index) => {
  //   return (
  //     <input
  //       type="text"
  //       value={value}
  //       onChange={(e) => console.log(e.target.value)}
  //       maxLength={1}
  //       key={index}
  //     />
  //   );
  // };

  return (
    <div className="modal-body px-5">
      <p className="modal-head">
        {/* <a
          onClick={(e) => {
            e.preventDefault();
            appContext.updateModalState();
          }}
          className="arrow mr-3"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <rect width="24" height="24" rx="4" fill="#F7F7F7" />
            <path
              d="M10.7384 17.7432L5.22953 12.0942C5.14607 12.0086 5.08681 11.9159 5.05175 11.816C5.01725 11.7162 5 11.6092 5 11.4951C5 11.3809 5.01725 11.274 5.05175 11.1741C5.08681 11.0742 5.14607 10.9815 5.22953 10.8959L10.7384 5.2469C10.8914 5.08998 11.0825 5.00781 11.3118 5.0004C11.5416 4.99355 11.74 5.07572 11.9069 5.2469C12.0738 5.40382 12.1609 5.59982 12.1682 5.83491C12.1748 6.07057 12.0947 6.27399 11.9278 6.44518L7.83788 10.6391H17.1653C17.4018 10.6391 17.6002 10.721 17.7604 10.8848C17.9201 11.0491 18 11.2526 18 11.4951C18 11.7376 17.9201 11.9407 17.7604 12.1045C17.6002 12.2688 17.4018 12.351 17.1653 12.351H7.83788L11.9278 16.5449C12.0808 16.7019 12.1609 16.9016 12.1682 17.1441C12.1748 17.3866 12.0947 17.5863 11.9278 17.7432C11.7747 17.9144 11.58 18 11.3435 18C11.107 18 10.9053 17.9144 10.7384 17.7432Z"
              fill="#565555"
            />
          </svg>
        </a> */}
        You have got mail
      </p>
      <p>Please check your email for OTP</p>
      <div className="mb-3 mt-4">
        <form onSubmit={handleSubmit(submitHandler)}>
          {/* <div className="row"> */}
          {/* <div className="col-md-2"></div>
            <div className="col-md-2">
              <input
                type="text"
                className="form-control verification-box py-4"
                maxLength="1"
                {...register("inp1", {
                  ...addPasswordOtpValidation,
                  onChange: () =>
                    autoTabField({
                      setFocus,
                      current: {
                        register: register("inp1"),
                        value: getValues("inp1"),
                      },
                      next: {
                        register: register("inp2"),
                        value: getValues("inp2"),
                      },
                    }),
                  //onPaste: (e) => console.log(e),
                })}
              />
            </div>
            <div className="col-md-2">
              <input
                type="text"
                className="form-control verification-box box-2 py-4"
                maxLength="1"
                {...register("inp2", {
                  ...addPasswordOtpValidation,
                  onChange: () =>
                    autoTabField({
                      setFocus,
                      current: {
                        register: register("inp2"),
                        value: getValues("inp2"),
                      },
                      next: {
                        register: register("inp3"),
                        value: getValues("inp3"),
                      },
                    }),
                })}
              />
            </div>
            <div className="col-md-2">
              <input
                type="text"
                className="form-control verification-box box-3 py-4"
                maxLength="1"
                {...register("inp3", {
                  ...addPasswordOtpValidation,
                  onChange: () =>
                    autoTabField({
                      setFocus,
                      current: {
                        register: register("inp3"),
                        value: getValues("inp3"),
                      },
                      next: {
                        register: register("inp4"),
                        value: getValues("inp4"),
                      },
                    }),
                })}
              />
            </div>
            <div className="col-md-2">
              <input
                type="text"
                className="form-control verification-box box-4 py-4"
                maxLength="1"
                {...register("inp4", addPasswordOtpValidation)}
              />
            </div>
            <div className="col-md-2"></div> */}
          <div className="otp-verify-wrapper">
            <OtpInput
              value={passCode}
              onChange={onChangePasscode}
              numInputs={4}
              separator={<span>&ensp;</span>}
              shouldAutoFocus="true"
              renderInput={(props) => <input {...props} />}
            />
          </div>
          {/* </div> */}
          <p className="text-center mt-4 code-txt">
            Please check your email for OTP
          </p>
          <Counter />
          <div className="row">
            <div className="col-md-1"></div>
            <div className="col-md-10 text-center">
              <button
                type="submit"
                disabled={appContext.loaderState}
                className="btn btn-primary sign-btn mt-5"
              >
                Continue
              </button>
            </div>
            <div className="col-md-1"></div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgetResetOtp;
